import { isEqual, isNil } from 'lodash';
import { EditableField, Field } from './Field';

export class GenericUntypedJsonBlobField implements EditableField {
  readonly jsonBlob: any;
  readonly fieldType = 'GenericUntypedJsonBlob';

  constructor(jsonBlob: any) {
    this.jsonBlob = jsonBlob;
  }

  validate(): string | null {
    return null;
  }

  isEqual(field: Field): boolean {
    return field instanceof GenericUntypedJsonBlobField && isEqual(this.jsonBlob, field.jsonBlob);
  }

  toFieldJson() {
    return this.jsonBlob;
  }

  toDisplayString(): string {
    // untyped blob — there is no meaningful human-readable form
    return '';
  }

  get isEmpty() {
    return isNil(this.jsonBlob);
  }
}
